module.exports = __webpack_public_path__ + "static/vw-golf-r-front-grill-blue-allstocksociety-600px-04fa07ff0218589b013386b30b07a5dc.jpg";